import { IMdlCustomDialogConfiguration, MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { Injectable } from '@angular/core';
import { DELETE_DIALOG_TOKEN, DeleteModalComponent, DeleteModalData, DeleteModalResult } from './delete/delete-modal.component';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ModalDialogService {

    constructor(private readonly dialogService: MdlDialogService) { }

    public showCustomDeleteDialog(data?: DeleteModalData): Observable<DeleteModalResult> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DeleteModalComponent,
            providers: [{
                provide: DELETE_DIALOG_TOKEN,
                useValue: data
            }],
            isModal: true,
            classes: 'modal-delete-dialog',
            styles: { 'width': '35%' },
            clickOutsideToClose: false
        };

        return this.dialogService.showCustomDialog(configDialog)
            .pipe(
                switchMap(dialog => dialog.onHide()),
                map(dialogResult => dialogResult)
            );
    }
}